<template>
<div>
    <Breadcrumbs main="Inventory" title="Categories" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Category</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">

                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="category_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    <template #cell(name)="data">
                                        <div class="category-wrapper">

                                            <!-- Main Category -->
                                            <div class="category-title">
                                                {{ data.item.name }}
                                            </div>



                                        </div>
                                    </template>

                                    <template #cell(subcategory)="data">
  <div class="category-wrapper">

    <div class="subcategory-list" v-if="data.item.subcategory?.length">

      <!-- Existing Subcategories -->
      <span
        v-for="sub in data.item.subcategory"
        :key="sub.id"
        class="subcategory-badge"
      >
        {{ sub.name }}

        <feather
          type="x"
          size="14px"
          style="color:#000; cursor:pointer;"
          v-b-tooltip.hover
          v-b-modal.modal-center
          title="Delete"
          @click="deleteCategory(sub.id)"
        />
      </span>

      <!-- Add Subcategory Badge -->
      <span
        class="subcategory-badge add-badge"
        @click="addSubCategory(data.item)"
        v-b-modal.modal-prevent-sub-category
      >
        <feather type="plus" size="14"></feather>
        Add
      </span>

    </div>

    <!-- If No Subcategory -->
    <div
      v-else
      class="subcategory-badge add-badge"
      @click="addSubCategory(data.item)"
      v-b-modal.modal-prevent-sub-category
    >
      <feather type="plus" size="14"></feather>
      Add Subcategory
    </div>

  </div>
</template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                          
                                            <div @click="editCategory(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCategory(data.item.id)" title="Delete"></feather>
                                            </div>

                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Category Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Category" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <b-form-group label="Category Name" label-for="name-input">
                <b-form-input v-model="category.name" placeholder="Enter category name"></b-form-input>
            </b-form-group>

        </form>
    </b-modal>

    <!-- Category Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Category" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <b-form-group label="Category Name" label-for="name-input">
                <b-form-input v-model="edit_category.name" placeholder="Enter category name"></b-form-input>
            </b-form-group>

        </form>
    </b-modal>

    <!-- Sub Category Create Modal -->
    <b-modal id="modal-prevent-sub-category" ref="modal" title="Add Subcategory" @show="resetSubCatModal" @hidden="resetSubCatModal" @ok="handleSubCatOk">
        <h6>Category: {{ selectedCategory }}</h6>
        <form ref="form" @submit.stop.prevent="handleSubCatSubmit">
            <b-form-group label="Subcategory Name" label-for="name-input">
                <b-form-input v-model="sub_category.name" placeholder="Enter subcategory name"></b-form-input>
            </b-form-group>
        </form>
    </b-modal>
    <!-- Category Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this category?</div>
    </b-modal>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import moment from "moment";
import {
    mapState
} from 'vuex';
export default {
    components: {
        Datepicker
    },

    data() {
        return {
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Category Name',
                    sortable: true
                },
                {
                    key: 'subcategory',
                    label: 'Subcategory',
                    sortable: true
                },

                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            category: {
                name: '',
            },

            edit_category: {
                id: '',
                name: '',
            },

            sub_category: {
                parent: '',
                name: '',
            },
            selectedCategory: '',

            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],

            temp_quotation: {}
        };
    },

    computed: {
        ...mapState({
            category_list: state => state.inventory.categories,
            loading: state => state.inventory.categoryLoading,
            error: state => state.inventory.categoryError,

        }),
        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        },

    },

    mounted() {
        this.$store.dispatch("inventory/fetchCategories").then(() => {
            this.items = this.category_list
            this.totalRows = this.items.length;
        });
    },

    methods: {
        onFiltered(filteredItems) {

            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.category.name = ''
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()

        },

        handleSubmit() {

            this.$store.dispatch("inventory/addCategory", this.category).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.category.name = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        // resetSubCatModal() {
        //     this.sub_category.name = ''
        //     this.selectedCategory = ''
        // },
        handleSubCatOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubCatSubmit()
        },
        handleSubCatSubmit() {

            this.$store.dispatch("inventory/addCategory", this.sub_category).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.sub_category.name = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-sub-category')
            })
        },

        addSubCategory(data) {
            this.sub_category.parent = data.id
            this.selectedCategory = data.name
        },

        editCategory(type) {
            this.edit_category.id = type.id
            this.edit_category.name = type.name

        },

        resetEditModal() {
            this.edit_category.name = ''

        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {

            this.$store.dispatch("inventory/updateCategory", {
                id: this.edit_category.id,
                name: this.edit_category.name,

            }).then(response => {
                console.log(this.edit_holiday)
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.edit_category.name = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },
        deleteCategory(id) {
            this.delete_value = id
        },
        handleDeleteOk() {
            this.$store.dispatch("inventory/deleteCategory", this.delete_value).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>

<style scoped>
.category-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.category-title {
    font-weight: 600;
    font-size: 14px;
    color: #333;
}

.subcategory-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.subcategory-badge {
    background: #eef2ff;
    color: #000000;
    padding: 6px 18px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    max-width: fit-content;
}
</style>
